module.exports = __webpack_public_path__ + "afe55df3bb8859bca8a8b684c6f4746a.svg";